import { useQuery } from '@tanstack/react-query';
import type { IntercomContact } from '@brand24-original/llm-types';
import { getIntercomContact } from '../../services/admin/AdminIntercomService';
import { adminIntercomKeys } from '../../query/admin/keys';

/** Pełna lista tagów kontaktu — na liście Intercom ucina ją do dziesięciu. Po kliknięciu w wiersz. */
export const useGetIntercomContact = (contactId: string | null) => {
  const { data, isLoading, isError } = useQuery<IntercomContact>({
    queryKey: adminIntercomKeys.contact(contactId ?? ''),
    queryFn: () => getIntercomContact(contactId!),
    enabled: !!contactId,
    staleTime: 60_000,
  });

  return { contact: data ?? null, isLoading, isError };
};
